module.exports = __webpack_public_path__ + "static/media/netlogo.4ee488fc.png";